module.exports = __webpack_public_path__ + "static/jack-mckinley-736e5ea8399da325b25d6eaf0888f7a9.jpg";